import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Article from "../pages/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artigo/cssbuy-spreadsheet",
    element: <Article />,
  },
  {
    path: "/artigo/cssbuy-seguro",
    element: <Article />,
  },
  {
    path: "/artigo/cssbuy-brasil",
    element: <Article />,
  },
  {
    path: "/artigo/cssbuy-yupoo",
    element: <Article />,
  },
  {
    path: "/artigo/cssbuy-tenis",
    element: <Article />,
  },
  {
    path: "/artigo/melhor-cssbuy-spreadsheet",
    element: <Article />,
  },
  {
    path: "/artigo/cssbuy-guia",
    element: <Article />,
  },
  {
    path: "/artigo/cssbuy-links",
    element: <Article />,
  },
  {
    path: "/artigo/cssbuy-roupas",
    element: <Article />,
  },
  {
    path: "/artigo/:slug",
    element: <Article />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;